module.exports = __webpack_public_path__ + "media/images/pages/img_living_03-f1588d2c4df63c811014a052af983139.jpg";